module.exports = __webpack_public_path__ + "8a5356e9/img/scraper-icon.df6ccde5.svg";